import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn combina clases condicionales (clsx) y resuelve conflictos de Tailwind
 * (tailwind-merge). Helper estándar del estilo shadcn/ui.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
